<div *ngIf="!mostrarFormulario" class="row animated fadeInRight">
  <!-- *FORMULARIO GUARDAR ROL  -->
  <app-lfsa-card-v2 *ngIf="!mostrarGridLista" [innTemplateButton]="innTemplateButton"
                    [innTemplate]="enviarTemplateEdit" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButton>
  </ng-template>
  <ng-template #enviarTemplateEdit>
    <form [formGroup]="formulario" class="form-group" novalidate>
      <div class="row">
        <div *ngIf="loading" class="col-md-12">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
        </div>
        <div *ngIf="!loading" class="form-group col-md-6">
          <app-lfsa-combo-box (change)="changeTipo()" [comboBox]="cmbTipos"
                              [control]="formulario.get('tipo') | formControl"
                              [idOpcion]="'id'" [id]="'tipo'" [label]="'Tipo*'"
                              [opcion]="'descripcion'"
                              formControlName="tipo">
          </app-lfsa-combo-box>
        </div>
        <div *ngIf="!loading" class="form-group col-md-6">
          <app-lfsa-combo-box [comboBox]="cmbLocalizaciones" [control]="formulario.get('localidad') | formControl"
                              [habilitar]="!formulario.get('tipo').value || formulario.get('tipo').value === 1"
                              [idOpcion]="'codigo'"
                              [id]="'localidad'" [label]="obligatorylocality ? 'Localidad*' : 'Localidad'"
                              [opcion]="'localidad'"
                              formControlName="localidad">
          </app-lfsa-combo-box>
        </div>
        <div *ngIf="!loading" class="form-group col-md-6">
          <app-lfsa-input [control]="formulario.get('fecha') | formControl" [dateMin]="today" [id]="'fecha'"
                          [label]="'Ingrese Fecha*'" [mostrarImg]="false" [placeholder]="'Fecha'" [rutaImagen]=""
                          [type]="'date'"
                          formControlName="fecha">
          </app-lfsa-input>
        </div>
      </div>
      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" [formularioValido]="formulario.invalid"
                                   [loading]="loading" [textBoton]="textBoton">
      </app-lfsa-botones-formulario>
    </form>
  </ng-template>
  <!-- *GRID LISTAR ROL -->
  <app-lfsa-card-v2 *ngIf="mostrarGridLista" [innTemplateButton]="innTemplateButtonAddRol"
                    [innTemplate]="enviarTemplate" [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo"
                    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <ng-template #innTemplateButtonAddRol>
    <div class="col-md-6">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <a (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.agregarFeriado}}
          </a>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #enviarTemplate>
    <section class="section">
      <div class="row">
        <div class="col-md-12 ">
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [columnDefs]="columnDefs"
                           [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
                           [ngStyle]="diccionarioModulo.agGrid.style" [pagination]="true"
                           [rowData]="rowData" [rowSelection]="rowSelection"
                           class="{{diccionarioModulo.agGrid.class}}" id="{{diccionarioModulo.agGrid.id}}"
                           [paginationPageSize]="diccionarioModulo.agGrid.paginacion">
          </ag-grid-angular>
        </div>
      </div>
    </section>
  </ng-template>
</div>
